import api from './client';

export interface DeletionRequestRow {
  id: string;
  /** What approving does: remove the object, or open a secret window. */
  kind: 'delete' | 'reveal';
  created_at: number;
  expires_at: number;
  requested_by_admin_id: string;
  requested_by_email: string;
  method: string;
  path: string;
  query: string;
  section: string | null;
  target_type: string | null;
  target_name: string | null;
  status: string;
  decided_at: number | null;
  decided_by_admin_id: string | null;
  decided_by_email: string | null;
  decided_by_name: string | null;
  decided_via: string | null;
  reject_reason: string | null;
  result_status: number | null;
  result_error: string | null;
  /** Whether the server would take this person's Approve / Reject. */
  can_approve?: boolean;
  can_reject?: boolean;
}

export async function getDeletionRequests(status?: string): Promise<DeletionRequestRow[]> {
  const qs = status ? `?status=${encodeURIComponent(status)}` : '';
  const res = await api.get<{ requests: DeletionRequestRow[] }>(`/admin/deletions${qs}`);
  return res.requests;
}

export async function approveDeletion(id: string): Promise<{ outcome: string }> {
  return api.post<{ outcome: string }>(`/admin/deletions/${id}/approve`, {});
}

export async function rejectDeletion(id: string, reason?: string): Promise<{ outcome: string }> {
  return api.post<{ outcome: string }>(`/admin/deletions/${id}/reject`, { reason });
}

export async function cancelDeletionRequest(id: string): Promise<void> {
  await api.delete(`/admin/deletions/${id}`);
}

export async function createTelegramLinkCode(): Promise<{ code: string; expires_at: number }> {
  return api.post<{ code: string; expires_at: number }>('/admin/deletions/telegram-link', {});
}
